import { SiteList } from '../config';
import { VendorCodes } from '../enums';
export var getClientVendorCode = function(clientPortalBase) {
    var _SiteList_find;
    var hostName = clientPortalBase || window.location.hostname;
    return ((_SiteList_find = SiteList.find(function(portal) {
        return portal.domains.some(function(domain) {
            return domain.hostname === hostName || domain.authHostname === hostName;
        });
    })) === null || _SiteList_find === void 0 ? void 0 : _SiteList_find.vendorCode) || VendorCodes.PCGL;
};
